export const MODULE_NAME = '@pressreader/ui-common';
